import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useCallback } from 'react';
import { Button, Col, Row, Spin, Tree } from 'antd';
import BusinessUnitAPI from 'restAPI/BusinessUnitAPI';
import { LoadingIcon } from 'components/Icons';
import BaseModal from 'components/BaseModal';
import { checkForOutOfBox } from '../utils';
import useFetchAllPermissions from 'hooks/useFetchAllPermissions';


const ViewPermissionsModal = React.forwardRef(({ role={}, allPermissions, history, location },ref) => {
  const [checkedKeys, setCheckedKeys] = useState();
  const [outOfBox, setOutOfBox] = useState(role.outOfBox);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [permissionTree] = useFetchAllPermissions(_.isEmpty(allPermissions));

  const allKeys = (allPermissions || permissionTree ).map((permission) => permission.key)

  const fetchPermissions = useCallback(() => {
    setCheckedKeys();
    const { promise, cancel } = BusinessUnitAPI.getRolePermissions(role.role);
    promise.then((data) => {
      setOutOfBox(data.outOfBox);
      return getSelectionFromPermissionMap(data);
    }, console.error).then(setCheckedKeys, _.noop);
    return cancel;
  }, [role.role]);

  const expandAll = () => {
    setExpandedKeys(allKeys);
  };

  const collapseAll = () => {
    setExpandedKeys([]);
  };

  useEffect(fetchPermissions, [fetchPermissions]);

  const removeQueryParam = () => {
    if (!location) {
      return;
    }
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.has('role')) {
      queryParams.delete('role')
      history.replace({
        search: queryParams.toString(),
      })
    }
  };

  return( 
  <>
    <BaseModal
      modalProps={{
        title: <>Showing Permissions for - {_.isNull(outOfBox) ? <LoadingIcon /> : checkForOutOfBox({...role, outOfBox})}</>,
        cancelBtn: false,
        okText: 'Ok',
      }}
      ref={ref}
      afterClose={removeQueryParam}
    >
      <Spin spinning={_.isUndefined(checkedKeys)} indicator={<LoadingIcon />}>
        <Row>
          <Col span={24} className="text-right">
            <Button size="small" onClick={expandedKeys.length ? collapseAll : expandAll}>{expandedKeys.length ? 'Collapse' : "Expand"} All</Button>
          </Col>
          <Col span={24}>
              <Tree
                onExpand={setExpandedKeys}
                expandedKeys={expandedKeys}
                checkable
                checkedKeys={checkedKeys}
                selectable={false}
                treeData={allPermissions || permissionTree}
              />
          </Col>
        </Row>
      </Spin>
    </BaseModal>
  </>
  )});

export default ViewPermissionsModal;


function getSelectionFromPermissionMap(data) {
  const { permissionSet = data } = data;
  return _.flatten(Object.keys(permissionSet).map((key) => {
    return permissionSet[key].map(key2 => `${key}#${key2}`);
  }));
}
